<div class="p-4">
    <div class="position-relative heading-border pb-3">
        <h1 class="fw-bold m-0 heading">Add Team Member</h1>
        <button type="button" class="position-absolute top-0 end-0 btn-close" aria-label="Close" (click)="activeModal.close('Close click')">
            <i class="bi bi-x-lg fw-bold"></i>
          </button>
    </div>
    
    <div class="modal-body p-0">
        <div class="row">
            <div class="col-sm-12">
                <input type="text" placeholder="Email" class="input w-100" [(ngModel)]="teamMember.email">
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 mt-3 mb-2">
                <h2 class="fw-bold mb-0">Credits</h2>
            </div>
            <div class="col-sm-4">
                <input type="number" placeholder="Audit/Editor" class="input w-100" [(ngModel)]="teamMember.audit">
            </div>
            <div class="col-sm-4">
                <input type="number" placeholder="Keyword Report" class="input w-100" [(ngModel)]="teamMember.keywordReport">
            </div>
            <div class="col-sm-4">
                <input type="number" placeholder="SERP" class="input w-100" [(ngModel)]="teamMember.serp">
            </div>
        </div>

        <div class="d-flex mt-4 justify-content-end">
            <button type="button" class="btn btn-outline-primary me-1 px-5" (click)="activeModal.close('Close click')">Cancel</button>
            <button type="button" class="btn btn-primary ms-1 px-5" (click)="addUser()">Add</button>
          </div>
    </div>
</div>